<template>
  <el-container id="tab">
    <el-aside :width="isCollapse ? '20px' : '300px'" v-if="activeName == 'second'">
      <el-card v-show="!isCollapse" class="box-card" shadow="never">
        <div slot="header">
          <span>商品类别</span>
          <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
        </div>
        <cascader-multiple ref="cascaderMultiple" :args="cascaderArgs" :default-checked-keys="defaultCheckedKeys" :default-disabled-keys="defaultDisabledKeys" :from="queryItem" @get-product-data="getProductData"></cascader-multiple>
      </el-card>
      <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
        <span style="text-align: center;">商品</span>
        <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
        <span style="text-align: center;">类别</span>
      </div>
    </el-aside>
    <el-main>
      <el-tabs type="border-card" v-model="activeName" @tab-click="tabClick">
        <el-tab-pane v-if="invCheckWay == 'A'" label="库存调整" name="first" ref="first">
          <query-form @getQueryForm="getQueryForm" :power="{ activeName, tag }" :billNo="billNo" v-if="activeName == 'first'"></query-form>
          <orderEntering :from="queryItem" @getCustomColumn="getCustomColumn" :btn-power="btnPower" :power="{ activeName, tag, billNo, hideColumnList }" v-if="activeName == 'first'"></orderEntering>
        </el-tab-pane>
        <el-tab-pane v-if="invCheckWay == 'B'" label="品牌/类别盘点" name="second" ref="second" :lazy="true">
          <query-form @getQueryForm="getQueryForm" @resetCascaderMultiple="resetCascaderMultiple" :power="{ activeName, tag }" :billNo="billNo" v-if="activeName == 'second'"></query-form>
          <orderEntering :from="queryItem" @getCustomColumn="getCustomColumn" :btn-power="btnPower" :power="{ activeName, tag, billNo, hideColumnList }" v-if="activeName == 'second'"></orderEntering>
        </el-tab-pane>
        <el-tab-pane v-if="invCheckWay == 'C' || invCheckWay == 'D'" label="整库盘点/盘空" name="third" ref="third" :lazy="true">
          <query-form @getQueryForm="getQueryForm" @setEmpty="setEmpty" :power="{ activeName, tag }" :billNo="billNo" v-if="activeName == 'third'"></query-form>
          <orderEntering :from="queryItem" @getCustomColumn="getCustomColumn" :btn-power="btnPower" :power="{ activeName, tag, empty, billNo, hideColumnList }" v-if="activeName == 'third'"></orderEntering>
        </el-tab-pane>
        <el-tab-pane v-if="invCheckWay == 'E'" label="库存报损" name="fourth" ref="fourth" :lazy="true">
          <query-form @getQueryForm="getQueryForm" :power="{ activeName }" :billNo="billNo" v-if="activeName == 'fourth'"></query-form>
          <orderEntering :from="queryItem" @getCustomColumn="getCustomColumn" :btn-power="btnPower" :power="{ activeName, tag, billNo, hideColumnList }" v-if="activeName == 'fourth'"></orderEntering>
        </el-tab-pane>
        <el-tooltip effect="light" placement="bottom" v-if="activeName.match(/third/i)">
          <div slot="content" class="tips">
            <!-- <span>1.整库盘点会把库房中有库存和库存为零的商品全部加载出来，没有发生过采购的商品不会被加载。</span> -->
            <span>整库盘空商品需要首先处理掉所有有库存占用的订单。</span>
          </div>
          <el-button style="position: fixed; top: 13px; right: 24px;" type="warning" icon="el-icon-info" size="mini">提示</el-button>
        </el-tooltip>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import cascaderMultiple from '@/components/common/cascaderMultiple.vue'
import queryForm from '@/components/invWare/invCheck/inventory/queryForm.vue'
import orderEntering from '@/components/invWare/invCheck/inventory/orderEntering.vue'
export default {
  name: "Inventory",
  props: ['billNo', 'tag', 'invCheckWay'],
  components: {
    cascaderMultiple,
    queryForm,
    orderEntering
  },
  data() {
    let billType = 'PKD'
    let activeName = 'first'
    let empty = ''
    if (this.invCheckWay == 'A') {
      activeName = 'first'
    } else if (this.invCheckWay == 'B') {
      activeName = 'second'
    } else if (this.invCheckWay == 'C') {
      activeName = 'third'
      empty = 'C'
    } else if (this.invCheckWay == 'D') {
      activeName = 'third'
      empty = 'D'
    } else if (this.invCheckWay == 'E') {
      activeName = 'fourth'
    }
    console.log(this.invCheckWay)
    return {
      isCollapse: false,
      activeName: activeName,
      empty: empty, // 整库盘点单还是整库盘空单
      billType,
      cascaderArgs: {
        billType: billType,
        searchType: 3
      },
      queryItem: {
        billType: billType
      },
      hideColumnList: [
        {
          "label": "条码",
          "prop": "invBarCode"
        },
        {
          "label": "生产日期",
          "prop": "productionDate"
        }
      ],
      defaultCheckedKeys: [],
      defaultDisabledKeys: [],
      btnPower: {}
    }
  },
  created() {
    this.getCustomColumn()
    this.getBtnPower()
    if (this.billNo) {
      this.getEditTabledata()
    }
  },
  methods: {
    async getBtnPower() {
      let menuID
      if (this.invCheckWay == 'A') {
        menuID = 162
      } else if (this.invCheckWay == 'B') {
        menuID = 160
      } else if (this.invCheckWay == 'C') {
        menuID = 112
      } else if (this.invCheckWay == 'D') {
        menuID = 112
      } else if (this.invCheckWay == 'E') {
        menuID = 164
      }
      const { data: res } = await this.$http.post('/Account/dataSearchVue/selectFunctionButtonAuth.html', this.Qs.stringify({ menuID }))
      res.result = JSON.parse(res.result)
      this.btnPower = JSON.parse(res.result.data)
      console.log(this.btnPower)
    },
    // 切换tab时更新本组件的表单信息
    tabClick(ref) {
      let invCheckWay = 'A'
      if (this.activeName == 'first') {
        invCheckWay = 'A'
      } else if (this.activeName == 'second') {
        invCheckWay = 'B'
      } else if (this.activeName == 'third') {
        invCheckWay = 'C'
      } else if (this.activeName == 'fourth') {
        invCheckWay = 'E'
      }
      this.$nextTick(() => {
        this.queryItem = { ...this.queryItem, ...ref?.$children[0]?.queryItem }
        top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/inventory?invCheckWay=${ invCheckWay }`)
      })
    },
    setEmpty (e) {
      this.empty = e
    },
    // 表单信息更改时触发，更新本组件的表单信息
    getQueryForm (e) {
      this.queryItem = { ...this.queryItem, ...e }
    },
    // 重置商品类别
    resetCascaderMultiple () {
      if (this.activeName == 'second') {
        this.$refs['cascaderMultiple'].getBrandData()
      }
    },
    // 品牌/类别盘点中左侧勾选时触发请求商品信息
    async getProductData ({ checked, row, leaf }) {
      let $table = this.$refs[this.activeName]?.$children[1]
      $table.tableLoading = true
      if (checked) {
        $table.deleteProductToOrder(leaf ? 'itemTypeID' : 'financialBrandID', row.value)
        const { data: res } = await this.$http.post('/Account/dataSearchVue/selectItemEnterDetailList.html', this.Qs.stringify({
          billType: 'PKD',
          warehouseID: this.queryItem.warehouse.value || '',
          [leaf ? 'secondType' : 'firstType']: row.type,
          [leaf ? 'secondValue' : 'firstValue']: row.value,
          searchType: 3,
        }))
        if (res.code != 'success') {
          $table.tableLoading = false
          this.$message.error(res.message)
          return false
        }
        let tempArr = JSON.parse(JSON.parse(res.result).data)
        const result = await $table.addProductToOrder(tempArr)
        if (result) $table.tableLoading = false
      } else {
        const res = await $table.deleteProductToOrder(leaf ? 'itemTypeID' : 'financialBrandID', row.value)
        if (res) $table.tableLoading = false
      }
    },
    // 复制或编辑，根据billNo获取单据详情
    getEditTabledata () {
      this.$nextTick(async () => {
        let $table = this.$refs[this.activeName]?.$children[1]
        let $queryForm = this.$refs[this.activeName]?.$children[0]
        $queryForm.isCanEnter = true
        $table.tableLoading = true
        const { data: res } = await this.$http.post('/Account/dataSearchVue/selectBillDetail.html', this.Qs.stringify({
          billType: this.billType,
          billNo: this.billNo
        }))
        let { headInfo, itemList } = JSON.parse(JSON.parse(res.result).data)
        if (res.code != 'success') return this.$message.error(res.message)
        let inWarehouse = $queryForm.queryForm.inWarehouse.selected = { value: headInfo.warehouseID, text: headInfo.warehouseName}
        $queryForm.queryForm.inWarehouse.list = $queryForm.queryForm.inWarehouse.list.filter(item => item.value != inWarehouse.value)
        $queryForm.queryForm.inWarehouse.list.unshift(inWarehouse)

        let salesman = $queryForm.queryForm.salesman.selected = { value: headInfo.salesmanID, text: headInfo.salesmanName}
        $queryForm.queryForm.salesman.list = $queryForm.queryForm.salesman.list.filter(item => item.value != salesman.value)
        $queryForm.queryForm.salesman.list.unshift(salesman)

        let deliverUser = $queryForm.queryForm.deliverUser.selected = { value: headInfo.entryUserID, text: headInfo.entryUserName}
        $queryForm.queryForm.deliverUser.list = $queryForm.queryForm.deliverUser.list.filter(item => item.value != deliverUser.value)
        $queryForm.queryForm.deliverUser.list.unshift(deliverUser)
        // $queryForm.inWarehouseSelect()

        $queryForm.selectProductList = itemList
        /**
         * 这里是禁止库存调整、库存报损删除的代码，仅仅限制了商品选择的dialog
         */
        // $queryForm.defaultDisabledKeys = itemList
        this.getQueryForm($queryForm.queryItem)
        $table.sum.invCheckLossAmt = Number(headInfo.invCheckLossAmt || 0)
        $table.sum.invCheckProfitAmt = Number(headInfo.invCheckProfitAmt || 0)
        $table.sum.totalAmt = Number(headInfo.totalAmt || 0)
        $table.sum.billInvQty = Number(headInfo.billInvQty || 0)
        $table.sum.billMedQty = Number(headInfo.billMedQty || 0)
        $table.sum.billSalQty = Number(headInfo.billSalQty || 0)

        if (this.invCheckWay == 'B') {
          this.defaultCheckedKeys = itemList.map(i => (
            {
              financialBrandID: i.financialBrandID,
              itemTypeID: i.itemTypeID,
            }
          ))
          this.defaultDisabledKeys = [ ...this.defaultCheckedKeys ]
        }
        const result = await $table.addProductToOrder(itemList)
        if (result) $table.tableLoading = false
      })
    },
    // 获取自定义列详情
    getCustomColumn () {
      this.$nextTick(async () => {
        let $table = this.$refs[this.activeName]?.$children[1]
        $table.tableLoading = true
        const { data: res } = await this.$http.post('/Account/dataSearchVue/selectColumnByFuncCode.html', this.Qs.stringify({ funcCode: 208 }))
        $table.tableLoading = false
        if (res.code != 'success') return this.$message.error(res.message)
        let tempArr = JSON.parse(res.result)
        this.hideColumnList = this.hideColumnList.map(i => {
          tempArr.forEach(j => {
            if (i.prop == j.prop) {
              i['isShow'] = j.isShow
              i['id'] = j.id
            }
          })
          return i
        })
      })
    }
  }
};
</script>

<style scoped lang="less">
#tab {
  // height: calc(100vh - 20px);
  .el-aside {
    .box-card {
      height: calc(100% - 2px);
      ::v-deep .el-card__header {
        padding: 8px 20px;
        height: 33px;
      }
      ::v-deep .el-card__body {
        padding: 0;
        height: calc(100% - 33px);
      }
    }
    .is-collapse {
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      border: 1px #DCDFE6 solid;
      cursor: pointer;
      background-color: rgba(83, 168, 255, 0.1);
      color: #409EFF;
    }
  }
  .el-main {
    padding: 0 0 0 6px;
    .el-tabs {
      height: calc(100% - 2px);
      box-shadow: none;
      ::v-deep .el-tabs__item {
        height: 34px;
        line-height: 34px;
      }
      ::v-deep .el-tabs__content {
        height: calc(100% - 45px);
        padding: 0 12px 12px;
        .el-tab-pane {
          height: 100%;
          .el-card {
            border-top: none;
          }
        }
      }
    }
  }
}
.tips {
  display: flex;
  flex-flow: column;
  font-size: 16px;
  color: #F56C6C;
  span:not(:nth-child(1)) {
    margin-top: 6px;
  }
  
}
</style>
